{
  "enum": {
    "IxcMutualfundsV1DividendAccrualStatus": {
      "ACTIVE": "Active",
      "FINALIZED": "Finalized",
      "PAID": "Paid",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcMutualfundsV1DividendAccrualSummaryName": {
      "DividendAccrualSummary": "Dividend Accrual Summary",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcMutualfundsV1DividendSource": {
      "OWNED": "Owned",
      "SWEEP": "Sweep",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcMutualfundsV1FundOrderAction": {
      "PURCHASE": "Purchase",
      "REDEEM": "Redeem",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcMutualfundsV1FundOrderAmountConversionReason": {
      "FULL_POSITION_REDEMPTION": "Full Position Redemption",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcMutualfundsV1FundOrderOutcome": {
      "CANCELED": "Canceled",
      "EXECUTED": "Executed",
      "REJECTED": "Rejected",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcMutualfundsV1FundOrderStatus": {
      "ACTIVE": "Active",
      "APPROVAL": "Approval",
      "DONE": "Done",
      "REJECTED": "Rejected",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcMutualfundsV1FundVenue": {
      "FUND_SERV": "Fund Serv",
      "JPMAM": "JPMAM",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcMutualfundsV1MutualFundsJobStatus": {
      "CREATING": "Creating",
      "DONE": "Done",
      "INCOMPLETE": "Incomplete",
      "PROCESSING": "Processing",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcMutualfundsV1MutualFundsTaskStatus": {
      "ERRORED": "Errored",
      "PENDING": "Pending",
      "PROCESSING": "Processing",
      "SUCCEEDED": "Succeeded",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcMutualfundsV1OperationType": {
      "DIVIDENDS_CALCULATE": "Dividends Calculate",
      "DIVIDENDS_PAY": "Dividends Pay",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcMutualfundsV1VenueOrderStatus": {
      "CANCELED": "Canceled",
      "CONFIRMED": "Confirmed",
      "REJECTED": "Rejected",
      "SETTLED": "Settled",
      "SUBMITTED": "Submitted",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcMutualfundsV1DividendAccrualQueryServiceDividendAccrualListFilterableFields": {
      "accountId": "Account",
      "assetId": "Asset",
      "firstDayOfMonth": "First Day of Month",
      "source": "Source",
      "status": "Status"
    },
    "IxcMutualfundsV1FundOrderQueryServiceFundOrderListFilterableFields": {
      "accountId": "Account",
      "data": {
        "asset": {
          "assetId": "Asset",
          "data": {
            "category": "Asset Category",
            "type": {
              "!type": "Asset Type",
              "equity": {
                "controls": {
                  "canBuy": "Equity: Can Buy",
                  "canEnterFractions": "Equity: Can Enter Fractions",
                  "canSell": "Equity: Can Sell"
                },
                "cusip": "Equity CUSIP"
              },
              "moneyMarket": {
                "classification": "Money Market: Classification",
                "controls": {
                  "canBuy": "Money Market: Can Buy",
                  "canEnterFractions": "Money Market: Can Enter Fractions",
                  "canSell": "Money Market: Can Sell"
                },
                "cusip": "Money Market: CUSIP",
                "navType": "Money Market: NAV Type"
              }
            }
          },
          "status": "Asset Status"
        },
        "instruction": {
          "action": "Action"
        }
      },
      "fundOrderId": "Fund Order",
      "programId": "Program",
      "status": "Status"
    },
    "IxcMutualfundsV1MutualFundsJobQueryServiceMutualFundsJobListFilterableFields": {
      "mutualFundsJobId": "Mutual Funds Job",
      "status": "Status"
    },
    "IxcMutualfundsV1MutualFundsTaskQueryServiceMutualFundsTaskListFilterableFields": {
      "accountId": "Account",
      "assetId": "Asset",
      "mutualFundsJobId": "Mutual Funds Job",
      "mutualFundsTaskId": "Mutual Funds Task",
      "status": "Status"
    },
    "IxcMutualfundsV1VenueOrderQueryServiceVenueOrderListFilterableFields": {
      "assetId": "Asset",
      "data": {
        "spec": {
          "action": "Action"
        },
        "venue": "Venue",
        "venueBatchId": "Venue Batch"
      },
      "status": "Status",
      "venueOrderId": "Venue Order"
    }
  },
  "oneOf": {
    "IxcMutualfundsV1DividendAccrualEventType": {
      "finalized": "Finalized",
      "pay": "Pay",
      "paymentResult": "Payment Result",
      "paymentsCompleted": "Payments Completed",
      "updated": "Updated"
    },
    "IxcMutualfundsV1FundOrderAmount": {
      "notional": "Notional",
      "quantity": "Quantity"
    },
    "IxcMutualfundsV1FundOrderEventType": {
      "cancelRequested": "Cancel Requested",
      "canceled": "Canceled",
      "executed": "Executed",
      "failed": "Failed",
      "rejected": "Rejected",
      "requested": "Requested",
      "reserved": "Reserved",
      "settled": "Settled",
      "submitted": "Submitted"
    },
    "IxcMutualfundsV1FundOrderInstructionTaxLotSelection": {
      "custom": "Custom",
      "wellKnown": "Well Known"
    },
    "IxcMutualfundsV1JobProgressData": {
      "dividendsCalculate": "Dividends Calculate"
    },
    "IxcMutualfundsV1JobSpec": {
      "dividendsCalculate": "Dividends Calculate",
      "dividendsPay": "Dividends Pay"
    },
    "IxcMutualfundsV1JobStats": {
      "dividendsCalculate": "Dividends Calculate"
    },
    "IxcMutualfundsV1MutualFundsJobEventType": {
      "allCreated": "All Created",
      "allFinished": "All Finished",
      "created": "Created",
      "incomplete": "Incomplete",
      "metricsUpdated": "Metrics Updated",
      "progressChecked": "Progress Checked",
      "sentinelReceived": "Sentinel Received",
      "tasksCreated": "Tasks Created"
    },
    "IxcMutualfundsV1MutualFundsTaskEventType": {
      "created": "Created",
      "errored": "Errored",
      "finished": "Finished",
      "recovered": "Recovered",
      "started": "Started"
    },
    "IxcMutualfundsV1TaskCreatedInfo": {
      "dividendsPay": "Dividends Pay"
    },
    "IxcMutualfundsV1TaskFinishedInfo": {
      "dividendsPay": "Dividends Pay"
    },
    "IxcMutualfundsV1TaskSpec": {
      "dividendsPay": "Dividends Pay"
    },
    "IxcMutualfundsV1TaskStartedInfo": {
      "dividendsPay": "Dividends Pay"
    },
    "IxcMutualfundsV1VenueOrderEventType": {
      "canceled": "Canceled",
      "confirmed": "Confirmed",
      "rejected": "Rejected",
      "settled": "Settled",
      "submitted": "Submitted"
    }
  },
  "searchEnum": {
    "IxcMutualfundsV1FundOrderQueryServiceFundOrderListSearchableFields": {
      "data": {
        "asset": {
          "data": {
            "type": {
              "equity": {
                "name": "Equity Name",
                "symbol": {
                  "base": "Equity Symbol Base"
                }
              },
              "moneyMarket": {
                "name": "Money Market Name",
                "symbol": {
                  "base": "Money Market Symbol Base"
                }
              }
            }
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxcMutualfundsV1DividendAccrualQueryServiceDividendAccrualListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcMutualfundsV1FundOrderQueryServiceFundOrderListSortableFields": {
      "data": {
        "asset": {
          "metadata": {
            "createdAt": "Asset Created At",
            "updatedAt": "Asset Updated At"
          }
        }
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcMutualfundsV1MutualFundsJobQueryServiceMutualFundsJobListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcMutualfundsV1MutualFundsTaskQueryServiceMutualFundsTaskListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcMutualfundsV1VenueOrderQueryServiceVenueOrderListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}